import React from 'react';
import ManageTaskDialog from './ManageTaskDialog';
import TaskRequestDialog from './TaskRequestDialog';
import Selectors from '../hooks/selectors';

const TaskDialogs = ({ theme }) => {
  const { allowManage, allowSave } = Selectors.useTaskDialogs();
  return (
    <>
      {allowSave && <TaskRequestDialog theme={theme} />}
      {allowManage && <ManageTaskDialog theme={theme} />}
    </>
  );
};

export default TaskDialogs;
